<template>
  <div class="main-content">
    <div 
      class="head-collapse"
      @click="switchCollapse">
      <h4>{{ title }}</h4>
      <div 
        class="custom-arrow"  
        :class="{openarrow: open }"
      ></div>
    </div>
    <slot class="slot-height" v-if="open"></slot>
  </div>
</template>

<script>
  export default {
    name:'custom-collapse',
    props: {
      title: {
        type: String,
        default: 'title'
      }
    },
    data() {
      return {
        open: false
      }
    },
    methods: {
      switchCollapse: function() {
        this.open = !this.open; 
      }
    }
  }
</script>

<style scoped>
  .custom-arrow {
    width: 8px;
    height: 8px;
    border-right: solid 2px white;
    border-bottom: solid 2px white;
    transform: rotate(-45deg);
    transition-duration: 0.2s;
    transition-property: transform;
  }

  .custom-arrow:hover {
    border-right: solid 3px white;
    border-bottom: solid 3px white;
    cursor: pointer;
  }

  .openarrow {
    transform: rotate(45deg);
  }

  .head-collapse {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .head-collapse:hover {
    cursor: pointer;
  }

  .head-collapse>h4 {
    margin: 0;
  }

  .main-content {
    margin-top: 24px;
    margin-bottom: 12px;
    padding-left: 12px;
    padding-right: 12px;
  }

  .slot-height {
    max-height: 30%;
  }
</style>